import { toast } from "react-toastify";

const variants = {
  success: { title: "انجام شد", fallback: "عملیات با موفقیت انجام شد.", duration: 4000 },
  error: { title: "خطایی رخ داد", fallback: "عملیات انجام نشد. دوباره تلاش کنید.", duration: 7000 },
  warning: { title: "توجه کنید", fallback: "لطفاً اطلاعات واردشده را بررسی کنید.", duration: 6000 },
};

function showMessage(type, message) {
  const variant = variants[type];
  const content = typeof message === "string" && message.trim() ? message : variant.fallback;
  return toast[type](
    <div className="admin-toast-content">
      <p className="admin-toast-title">{variant.title}</p>
      <p className="admin-toast-message">{content}</p>
    </div>,
    { toastId: `${type}:${content}`, autoClose: variant.duration, role: type === "error" ? "alert" : "status" }
  );
}

export const successMessage = (message) => showMessage("success", message);
export const errorMessage = (message) => showMessage("error", message);
export const warningMessage = (message) => showMessage("warning", message);
